import { MDCTemporaryDrawer } from '@material/drawer/dist/mdc.drawer';

/**
 * Init MDC Temporary Drawers and their toggles.
 * 
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-drawer
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMDCTemporaryDrawer(drawer, startOpen) {
	const MDCTemporaryDrawerInst = new MDCTemporaryDrawer(drawer);
	MDCTemporaryDrawerInst.open = startOpen;
	// init toggles
	const toggles = document.querySelectorAll('*[aria-controls="' + drawer.id + '"]');
	toggles.forEach((toggle, i) => {
		toggle.addEventListener('click', (e) => {
			e.preventDefault();
			MDCTemporaryDrawerInst.open = ! MDCTemporaryDrawerInst.open;
			toggle.setAttribute('aria-expanded', ! MDCTemporaryDrawerInst.open);
		});
	});
}

export function initMDCTemporaryDrawers() {
	const drawers = document.querySelectorAll('.mdc-drawer--temporary');
	drawers.forEach((drawer, i) => {
		initMDCTemporaryDrawer(drawer);
	});
}


export function initSearchDrawer() {

	let timeout = null;

	function handleSearchDrawerChange(e) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			['pages', 'projects', 'posts'].forEach((restBase, i) => {
				fetch(`/wp-json/wp/v2/${restBase}?_embed=true&search=${encodeURIComponent(e.target.value)}&per_page=3`)
					.then((response) => {
						if (response.status === 200) {
							return response.json();
						} else {
							throw new Error(`Error fetching posts from "${restBase}"`);
						}
					})
					.then((data) => {
						handleSearchDrawerResults(restBase, data);
					})
					.catch((err) => {
						console.error(err);
					});
			});
		}, 750);
	}

	const drawer = document.querySelector('#drawer_search');

	if (drawer) {
		const search = drawer.querySelector('input[name="s"]');
		if (search) {
			search.addEventListener('keyup', (e) => handleSearchDrawerChange(e));
			search.addEventListener('change', (e) => handleSearchDrawerChange(e));
		}
	}
}	

function handleSearchDrawerResults(restBase, data) {
	if (restBase && data) {
		const resultsContainer = document.querySelector(`#drawer_search_instant_results_${restBase}`);
		const errorsContainer = document.querySelector(`#drawer_search_instant_errors_${restBase}`);
		if (resultsContainer) {
			if (data.length > 0) {
				let lineItems = [];
				data.forEach((post, i) => {
					const lineItem = prepareSearchDrawerLineItem(post);
					lineItems.push(lineItem);
				});
				errorsContainer.setAttribute('hidden', true);
				resultsContainer.innerHTML = lineItems.join('');
			} else {
				errorsContainer.removeAttribute('hidden');
				resultsContainer.innerHTML = '';
			}
		} else {
			console.error(`#drawer_search_instant_results_${restBase} not found`);
		}
	}
}

function prepareSearchDrawerLineItem(post) {
	const { title, excerpt, link } = post;
	return `
		<a href="${link}" class="mdc-list-item">
			<span class="mdc-list-item__text">
				${title.rendered}
				<span class="mdc-list-item__secondary-text">
					${excerpt.rendered.replace(/(<p>|<\/p>)/g, '')}
				</span>
			</span>
		</a>
	`;
}